"use client";

import { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";

interface CurrencySelectorProps {
  selectedCurrency: string;
  onCurrencyChange: (symbol: string) => void;
}

const currencySymbols = ["$", "€", "£", "¥", "₩", "₿", "₦", "₹", "₽", "₺", "₫", "₴", "₲", "₡", "₱", "₭", "₪", "₨", "₸", "₼", "₾"];

export default function CurrencySelector({ selectedCurrency, onCurrencyChange }: CurrencySelectorProps) {
  const [open, setOpen] = useState(false);
  const [menuPos, setMenuPos] = useState<{ top: number; left: number; width: number }>({ top: 0, left: 0, width: 0 });
  const wrapperRef = useRef<HTMLDivElement>(null);

  const toggleOpen = () => {
    if (!open && wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      setMenuPos({ top: rect.bottom + 4, left: rect.left, width: rect.width });
    }
    setOpen(!open);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="dropdown-menu">
      <div className="custom-select" ref={wrapperRef}>
        <div
          className={`selected-option ${open ? "open" : ""}`}
          onClick={toggleOpen}
        >
          {selectedCurrency}
          <span className={`arrow ${open ? "up" : "down"}`} />
        </div>
      </div>

      {open &&
        createPortal(
          <ul
            className="options-list"
            style={{
              position: "fixed",
              top: `${menuPos.top}px`,
              left: `${menuPos.left}px`,
              width: `${menuPos.width}px`,
              zIndex: 9999,
            }}
          >
            {currencySymbols.map((sym) => (
              <li
                key={sym}
                role="option"
                aria-selected={sym === selectedCurrency}
                className={sym === selectedCurrency ? "active" : ""}
                onMouseDown={() => {
                  onCurrencyChange(sym);
                  setOpen(false);
                }}
              >
                {sym}
              </li>
            ))}
          </ul>,
          document.body
        )}
    </div>
  );
}
